import { useQuery } from '@tanstack/react-query';
import projectPlanDraftService from '@services/projectPlanDraft';

export const PROJECT_PLAN_DRAFT_QUERY_KEY = 'projectPlanDraft';

/**
 * Sprint 31, story-161. `refetchInterval` is the 2s-while-`GENERATING` poll described in
 * `docs/architecture.md`'s `## State Management` section — the mutations that create/revise/
 * retry a draft return it immediately in `GENERATING`, and this hook is what picks up the
 * eventual `READY`/`FAILED` transition.
 */
export const useProjectPlanDraft = (draftId?: string) => {
  return useQuery({
    queryKey: [PROJECT_PLAN_DRAFT_QUERY_KEY, draftId],
    queryFn: () => projectPlanDraftService.getProjectPlanDraft(draftId as string),
    enabled: !!draftId,
    refetchInterval: (query) => (query.state.data?.status === 'GENERATING' ? 2000 : false),
  });
};

export default useProjectPlanDraft;
